import { List } from "antd";

const ROW_WIDTHS = [
  { name: 110, phone: 72 },
  { name: 88, phone: 60 },
  { name: 124, phone: 80 },
  { name: 96, phone: 68 },
];

const TableChartEmpty = () => (
  <div style={{ marginTop: -12 }}>
    {ROW_WIDTHS.map((row, i) => (
      <div
        key={i}
        style={{
          display: "flex",
          alignItems: "center",
          gap: 12,
          padding: "12px 0",
          borderBottom: i < ROW_WIDTHS.length - 1 ? "1px solid #f5f5f5" : "none",
        }}
      >
        <div style={{ width: 32, height: 32, borderRadius: "50%", background: "#f0f1f3", flexShrink: 0 }} />
        <div style={{ flex: 1 }}>
          <div style={{ width: row.name, height: 12, background: "#eff0f2", borderRadius: 3, marginBottom: 6 }} />
          <div style={{ width: row.phone, height: 9, background: "#f5f5f7", borderRadius: 3 }} />
        </div>
        <div style={{ width: 82, height: 22, background: "#f0f1f3", borderRadius: 4 }} />
      </div>
    ))}
    <div style={{ textAlign: "center", paddingTop: 8, fontSize: 12, color: "#9ca3af" }}>
      No registrations yet
    </div>
  </div>
);

const TableChart = ({
  data,
}: {
  data: {
    first_name: string;
    last_name: string;
    phone: string;
    ticket_name: string;
    quantity: string;
  }[];
}) => {
  if (!data?.length) return <TableChartEmpty />;

  return (
    <List
      itemLayout="horizontal"
      dataSource={data}
      style={{ marginTop: -12 }}
      renderItem={(item) => (
        <List.Item className="recent-registrations">
          <List.Item.Meta
            style={{ alignItems: "center" }}
            title={
              <span className="text-black font-semibold capitalize text-[14px]">
                {item.first_name || "" + " " + item.last_name || ""}
              </span>
            }
            description={<span className="text-[12px]">{item.phone}</span>}
          />
          <div>
            {item.ticket_name} x {item.quantity ?? 1}
          </div>
        </List.Item>
      )}
    />
  );
};

export default TableChart;
